import { z } from 'zod'

import ZAction from '@/app/module/campaigns/types/schemas/actions/all-actions'

import ZBasePart from './base'

const ZQuotaActionsPart = ZBasePart.extend({
  quotaActions: z.object({
    onExhausted: z.array(ZAction),
    onOpen: z.array(ZAction),
  }),
})

export default ZQuotaActionsPart
